import {$, $$} from "functions/dom";
import {SelectInput, SelectInputAddable} from "components/SelectInput";
import {DatePicker, DatePickerTwo, MonthPicker, TimePicker} from "components/DatePicker";
import {InputNumeric} from "components/InputNumeric";
import {TextEditor, TextEditorFull} from "components/TextEditor";
import {CalendarTable} from "components/CalendarTable";
import {Tooltip} from "components/Tooltip";
import {FileDrop, FileProfileDrop} from "components/FileDrop";

export function closeAllDropDown() {
    window.addEventListener("click", (e) => {
        if (!e.target.matches('.icon.fi-rr-menu-dots-vertical') && !e.target.matches('.table_drop_action')) {
            $$('.table_drop_action').forEach(elm => {
                if (elm.classList.contains("active")) {
                    elm.classList.remove("active");
                }
            });
        }

        if ($(".dropdown .default_option") !== null) {
            if (!e.target.matches('.dropdown .default_option')) {
                if ($(".dropdown .default_option + ul").classList.contains("active")) {
                    $(".dropdown .default_option + ul").classList.remove("active");
                }
            }
        }

        if (!e.target.matches('.JsShowNotification')) {
            $$('.JsShowNotification').forEach(elm => {
                if (elm.parentElement.querySelector('.notifications_list').classList.contains("active")) {
                    elm.parentElement.querySelector('.notifications_list').classList.remove("active");
                }
            });
        }

        if (!e.target.matches('.default_option')) {
            $$('.dropdownList:not(.noEvent) > ul').forEach(elm => {
                if (elm.classList.contains("active")) {
                    elm.classList.remove("active");
                }
            });
        }
    });
}


export function registerCustomElements() {
    customElements.define("custom-select", SelectInput, {extends: "select"})
    customElements.define("custom-select-addable", SelectInputAddable, {extends: "select"})
    customElements.define("time-picker", TimePicker, {extends: "input"})
    customElements.define("date-picker", DatePicker, {extends: "input"})
    customElements.define("month-picker", MonthPicker, {extends: "input"})
    customElements.define("date-picker-two", DatePickerTwo, {extends: "input"})
    customElements.define("number-format", InputNumeric, {extends: "input"})
    customElements.define("text-editor", TextEditor, {extends: "textarea"})
    customElements.define("text-editor-full", TextEditorFull, {extends: "textarea"})
    customElements.define("calendar-form", CalendarTable, {extends: "div"})
    customElements.define("custom-tooltip", Tooltip, {extends: "button"})
    customElements.define("file-upload", FileDrop, {extends: "input"})
    customElements.define("profile-upload", FileProfileDrop, {extends: "input"})
}
